// extracted by mini-css-extract-plugin
export default {"wrapper":"Xy","subscription":"Yy","select_item":"Zy","is_selected":"az","otb":"bz","radio":"cz","first_row":"ez","prices":"fz","italic":"gz","info_wrapper":"hz","first_month":"iz","separator":"jz","checkmark":"kz","bullets":"lz","bullet":"mz","checkmarkText":"nz","button":"oz","discountBadge":"pz"};
    if(module.hot) {
      // 1713912565690
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  